import { KeyValueModel } from "model";
import { EnumTipoPropagandaLocal } from "model/enums/enum-tipo-propaganda-local";


export const TipoPropagandaLocalMock: KeyValueModel[] = [
    new KeyValueModel(EnumTipoPropagandaLocal.Ambos, "Ambos"),
    new KeyValueModel(EnumTipoPropagandaLocal.Pdv, "Pdv"),
    new KeyValueModel(EnumTipoPropagandaLocal.Retaguarda, "Retaguarda"),
];
